export const FundsUsed = [
  { value: 'cancer_treatment', text: 'Cancer treatment' },
  { value: 'accident_treatment', text: 'Accident treatment' },
  { value: 'liver_kidney_transplant', text: 'Liver/Kidney transplant' },
  { value: 'heart_operation', text: 'Heart operation' },
  { value: 'premature_baby', text: 'Pre-mature baby care (NICU)' },
  { value: 'medicines_treatment', text: 'Medicines (Ongoing treatment)' },
  { value: 'memorial', text: 'Memorial (Patient expired)' },
  { value: 'others', text: 'Others' }
];